// extracted by mini-css-extract-plugin
export default {"heading":"UA-z","corrected":"VA-z","redirectVerbiageContainer":"WA-z","redirectVerbiageText":"XA-z"};